<template>
  <button type="button" class="btn-map-close">
    <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4L26 26" stroke="#212529" stroke-width="2" stroke-linecap="round"/>
      <path d="M4 25.9706L26 3.97058" stroke="#212529" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>
</template>
